<template>
  <v-list nav dense>
    <template v-for="(item, key) in items">
      <v-list-item
        :key="key"
        link
        :to="item.path"
        active-class="white--text"
        v-if="item.isAuthorized"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-content v-on="on">
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>
          <span>{{ item.title }}</span>
        </v-tooltip>
      </v-list-item>
    </template>
  </v-list>
</template>
<script>
const API_ENDPOINT = "/api/routing";
export default {
  data: () => ({
    items: []
  }),
  methods: {
    getMenu() {
      this.$axios
        .get(`${API_ENDPOINT}/ec`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    }
  },
  mounted() {
    this.getMenu();
  }
};
</script>